import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  OnDestroy,
  OnInit,
  ViewContainerRef
} from '@angular/core';
import { environment } from '../../../environments/environment';
import {OnDestroy$, takeUntilDestroyed} from '@pdtec/ngx-observable-lifecycle';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {HTTPSearchResultTourMap} from 'src/app/models';
import {EventBusService} from 'src/app/services/event-bus.service';
import {GmapLoaderService} from 'src/app/services/gmap-loader.service';
import {ToursStateService} from 'src/app/services/tours-state.service';
import {GoogleMapProvider} from './google-map-provider';
import {AnalyticService} from "../../services/analytic.service";
import {HttpSearchService} from "../../services/search/search-requests.service";
import {SearchService} from "../../services/search/search.service";

@Component({
  selector: 'app-tours-map',
  templateUrl: './tours-map.component.html',
  styleUrls: [
    './tours-map.component.scss',
    '../../../../../../build/assets/desktop/_include/scss/tours-map-layout.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class ToursMapComponent extends OnDestroy$ implements OnInit, OnDestroy {
  #provider: GoogleMapProvider;

  private tours: HTTPSearchResultTourMap[] = [];
  private tourIdsInProvider = [];

  private mainSearchSubscription: Subscription;
  private extSearchSubscription: Subscription;
  private postfiltersSubscription: Subscription;

  private searchId: string;
  private searchIsDone: boolean;
  messages: any = {};

  constructor(
    private googleMapLoader: GmapLoaderService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef,
    private eventBus: EventBusService,
    private searchService: SearchService,
    private httpSearchService: HttpSearchService,
    private state: ToursStateService,
    private analyticService: AnalyticService,
  ) {
    super();
  }

  ngOnInit() {
    this.searchService.newSearchStarted$
      .pipe(
        filter(searchId => !!searchId)
      )
      .subscribe((searchId) => {
        this.searchId = searchId;
        this.searchIsDone = false;

        this.mainSearchSubscription?.unsubscribe();
        this.extSearchSubscription?.unsubscribe();
        this.postfiltersSubscription?.unsubscribe();

        this.tours = [];
        this.tourIdsInProvider = [];
        if (this.#provider) {
          this.#provider.removeAllMarker();
          // this.subscribeToSearch();
        }
      });

    // this.searchService.searchIsDone$
    //   .pipe(
    //     filter(() => !!this.#provider),
    //     switchMap(() => this.httpSearchService.getMapTours(this.searchId, this.state.getState()))
    //   )
    //   .subscribe((tours) => {
    //     this.updateMapTours(tours);

    //     this.searchIsDone = true;

    //     this.mainSearchSubscription?.unsubscribe();
    //     this.extSearchSubscription?.unsubscribe();
    //   });

    // Подписка на кнопку "Показать на карте"
    this.eventBus.toggleMap$
      .pipe(
        takeUntilDestroyed(this),
        filter(v => v === true)
      )
      .subscribe(() => {
        this.googleMapLoader.load().subscribe(
          () => {
          },
          (err) => console.error(err),
          () => {
            if (!this.#provider) {
              this.#provider = new GoogleMapProvider(this.componentFactoryResolver, this.viewContainerRef);
              this.#provider.initMap();

              this.eventBus.trackEventInitMap$.subscribe((data) => {
                this.analyticService.trackEvent('initMap', data);
              });

              this.httpSearchService.getMapTours(this.searchId, this.state.getState())
                .subscribe((tours) => {
                  this.updateMapTours(tours);
                });

              // this.subscribeToSearch();
            } else {
              // @see: https://developers.google.com/maps/documentation/javascript/reference/map#Map.fitBounds
              // когда карта скрыта, то нельзя произвести центрирование, в начале нужно показать карту, поэтому
              // ставим setTimeout()
              setTimeout(() => this.#provider.center(), 100);
            }
          }
        );
      });

    this.searchService.mapTours$
      .pipe(
        filter(() => !!this.#provider)
      )
      .subscribe((tours) => {
        this.updateMapTours(tours);
      });
  }

  ngOnDestroy() {
  }

  private updateMapTours(tours: HTTPSearchResultTourMap[]): void {
    this.tours = tours;
    this.tourIdsInProvider = [];
    this.#provider.removeAllMarker();

    this.setMapPointers();
    this.#provider.center();
  }

  private setMapPointers() {
    this.tours.forEach(tour => {
      if (this.tourIdsInProvider.indexOf(tour.id) === -1) {
        this.tourIdsInProvider.push(tour.id);
        this.#provider.addMarker(tour);
      }
    });
  }

  protected readonly environment = environment;
}
